'use client';

import { createContext, useContext } from 'react';

const CardPositionContext = createContext<number | null>(null);

export const CardPositionProvider = CardPositionContext.Provider;

export function useCardPosition(fallback: number | undefined): number | undefined {
  const position = useContext(CardPositionContext);
  return position ?? fallback;
}
